import { createSelector } from "reselect";

const getMyBookingsNotification = state => state?.myBookings?.notification;

export const getMyBookingsCustomerRequestsCount = createSelector(
	[getMyBookingsNotification],
	(notification = {}) => {
		return notification?.totalNotRead || 0;
	}
);
